module.exports = __webpack_public_path__ + "assets/img/7-1.e8b2b97e.png";